import styled from '@emotion/styled'

export const PhoneFields = styled.div`
  display: grid;
  column-gap: 20px;
  grid-template-columns: 50% 50%;
`
